/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Asset, Asset$inboundSchema } from "./asset.js";

export type UploadFunctionsResult = {
  asset: Asset;
};

/** @internal */
export const UploadFunctionsResult$inboundSchema: z.ZodMiniType<
  UploadFunctionsResult,
  unknown
> = z.object({
  asset: Asset$inboundSchema,
});

export function uploadFunctionsResultFromJSON(
  jsonString: string,
): SafeParseResult<UploadFunctionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UploadFunctionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UploadFunctionsResult' from JSON`,
  );
}
